export default {
  WHITE: 'white',
  TRANSPARENT: 'transparent',
  GREY: 'grey',
};
